<template>
  <div>
    <div class="row mb-30">
      <div class="col-12">
        <account-type-tabs selected="students" />
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="dashboard-card">
          <student-table
            :students="students"
            :sorted-column="sortedColumn"
            :on-sort="onSort"
            :send-message="sendMessage"
            :view-student="viewStudent"
            @impersonate="(id) => $emit('impersonate', id)"
          />
          <div v-if="!loading" class="border-top text-center">
            <div v-if="pageToken" class="mt-3">
              <button 
                class="btn btn-primary" 
                @click="loadStudents()">

                Load More Results
              </button>
            </div>

            <div v-else class="mt-3">
              <p>
                <font-awesome-icon 
                  :icon="['fas', 'check-circle']" 
                  class="icon alt" /> 
                All Results Loaded
              </p>
            </div>
          </div>
          <loader v-else style="width: 100%" />
        </div>
      </div>
    </div>

    <send-message-modal ref="sendMessageModal" />

    <view-student-modal
      ref="viewStudentModal"
      :reload-students="reloadStudents"
    />
  </div>
</template>

<script>
import moment from 'moment'
import Loader from '@/components/Loader.vue';
import SendMessageModal from '@/components/modals/SendMessageModal.vue';
import AccountTypeTabs from './components/AccountTypeTabs.vue';
import StudentTable from './components/StudentTable.vue';
import ViewStudentModal from './components/ViewStudentModal.vue';
import StudentClient from '@/api/StudentClient';

export default {
  name: 'SuperAdminStudents',

  components: {
    Loader,
    SendMessageModal,
    AccountTypeTabs,
    StudentTable,
    ViewStudentModal
  },

  props: {
    search: {
      type: String,
      required: true
    },
    csvBus: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      studentsClient: new StudentClient(this.$http),
      timeout: null,

      loading: false,

      limit: 20,
      pageToken: 'ByDateJoinedDescendingStudentsReportPageToken',
      sortedColumn: 'ByDateJoinedDescendingStudentsReportPageToken',

      students: [],
    };
  },

  watch: {
    search() {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
      this.timeout = setTimeout(() => this.reloadStudents(), 750);
    }
  },

  mounted() {
    this.csvBus.$on('generate', this.generateCsv);
    this.loadStudents();
  },

  destroyed() {
    this.csvBus.$off('generate', this.generateCsv);
  },

  methods: {
    onSort(id) {
      this.sortedColumn = id;
      return this.reloadStudents();
    },
    reloadStudents() {
        this.pageToken = this.sortedColumn;
        this.students = [];
        return this.loadStudents();
    },
    async loadStudents() {
      try{
        this.loading = true;
        let searches = undefined;
        if (this.search) {
          searches = this.search.split(/\s/)
            .filter(split => !!split);
        }

        const response = await this.studentsClient.getStudentsForBetterMyndAdmin(
          searches,
          this.pageToken,
          this.limit,
        );

        this.pageToken = response.nextPageToken;

        for(const student of response.students.map(x => ({
          ...x,
          dateJoined: moment(x.dateJoined),
          lastLogin: x.lastLogin ? moment(x.lastLogin) : null
        }))) {

          this.students.push(student);
        }
      } catch (ex) {
        console.error(ex);
      } finally {
        this.loading = false;
      }
    },

    sendMessage(filters) {
      this.$refs.sendMessageModal.show(filters.student);
    },
    async viewStudent(student) {
      this.$refs.viewStudentModal.show(student);
    },
    async generateCsv() {
      try {
        let content = 'FirstName,LastName,Email,IsActive,DateJoined,LastLogin,UsCityName,UsStateName,Institutions\n';
        let csvPageToken = this.sortedColumn;

        let searches = undefined;
        if (this.search) {
          searches = this.search.split(/\s/)
            .filter(split => !!split);
        }

        while(csvPageToken) {
          const response = await this.studentsClient.getStudentsForBetterMyndAdmin(
            searches,
            csvPageToken,
            50,
          );

          csvPageToken = response.nextPageToken;

          for(const student of response.students) {
            let line = `"${student.firstName}",`
              + `"${student.lastName}",`
              + `"${student.email}",`
              + `"${student.isActive}",`
              + `"${moment.tz(student.dateJoined, moment.tz.guess()).format('M/D/yyyy')}",`
              + `"${student.lastLogin ? moment.tz(student.lastLogin, moment.tz.guess()).format('M/D/yyyy h:mm a (z)') : ''}",`
              + `"${student.usCityName ? student.usCityName : ''}",`
              + `"${student.usStateName ? student.usStateName : ''}","`;

            for(let i = 0; i < student.institutions.length; i++) {
              line += student.institutions[i].name;

              if(i > 0)
                line += '|';
            }
            
            line += '"\n';

            content += line;
          }
        }
        this.csvBus.$emit('success', { content, file: `students-for-bettermynd-admin-${moment().toISOString()}.csv` });
      } catch (e) {
        this.csvBus.$emit('error', e);
      }
    }
  }
};
</script>
